module.exports = __webpack_public_path__ + "img/确认订单.0c0c4d96.png";